// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"f22533e0","502":"dec4c112","3048":"f22533e0","3350":"f22533e0","3851":"a43fe238"}[chunkId] + ".chunk.css";
};